// @generated shadcn/ui - vendored; do not hand-edit. Regenerate with the shadcn CLI.
import { cn } from "@shared/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      {...props}
    />
  )
}

export { Skeleton }
